import { useEffect } from 'react';

import { SITE_URL } from '@blind-kings/site-config';

export type PageMeta = {
  title: string;
  description: string;
  path?: string;
  noindex?: boolean;
};

const SITE = SITE_URL;
const DEFAULT_IMAGE = `${SITE}/og-share.png`;

function upsertMeta(
  attr: 'name' | 'property',
  key: string,
  content: string
) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel: string, href: string) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function upsertRobots(noindex: boolean) {
  upsertMeta('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');
}

/** Updates document title and primary meta tags for the current route. */
export default function usePageMeta({
  title,
  description,
  path = '/',
  noindex = false,
}: PageMeta) {
  useEffect(() => {
    const fullTitle =
      title === 'Blind Kings' ? title : `${title} | Blind Kings`;
    document.title = fullTitle;
    const url = `${SITE}${path}`;

    upsertMeta('name', 'description', description);
    upsertMeta('property', 'og:title', fullTitle);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', url);
    upsertMeta('property', 'og:image', DEFAULT_IMAGE);
    upsertMeta('name', 'twitter:title', fullTitle);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', DEFAULT_IMAGE);
    upsertLink('canonical', url);
    upsertRobots(noindex);
  }, [title, description, path, noindex]);
}
